import { PdfGeneratorContract } from '@terra/shared-contracts-pdf-generator';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'pdf-generator';

export const pdfGeneratorClient = createTerraOrpcClient({
  contract: PdfGeneratorContract,
  serviceName: SERVICE_NAME,
});
